import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Reports from "../../component/report/reports.js";

class Reportscon extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
        };

    }

  componentWillMount() {
      /* import les reports */
      this.props.getReportsAction().then(res => {
          this.setState({loading: false})
      }).catch(err => {
          this.props.displaySnackbar("error", "Erreur de chargement");
          this.setState({loading: false})
      })
  }

  render(){
    return <Reports reports={this.props.reports} loading={this.state.loading}></Reports>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Reportscon);



// WEBPACK FOOTER //
// ./src/container/report/reports-container.js